var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.37 3.5h15.26q.462 0 .776.305.313.306.313.757 0 .452-.313.758a1.07 1.07 0 0 1-.777.305H4.371q-.464 0-.777-.305a1.01 1.01 0 0 1-.313-.758q0-.45.313-.757.313-.305.777-.305m0 17q-.462 0-.776-.305a1.01 1.01 0 0 1-.313-.758v-5.312H3.09q-.518 0-.845-.385a.99.99 0 0 1-.218-.89l1.09-5.312q.082-.372.382-.611.3-.24.68-.24H19.82q.383 0 .681.24.3.239.382.61l1.09 5.313a.99.99 0 0 1-.218.89q-.327.385-.845.385h-.19v5.313q0 .45-.314.757a1.07 1.07 0 0 1-.777.305q-.462 0-.776-.305a1.01 1.01 0 0 1-.314-.758v-5.312h-4.36v5.313q0 .45-.312.757a1.07 1.07 0 0 1-.777.305zm1.09-2.125H12v-4.25H5.46z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreFill);
export default __webpack_public_path__ + "static/media/store_fill.0e672ab20497d5833be2490c4dd5ddab.svg";
export { ForwardRef as ReactComponent };